import { Grid, styled, Box } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';

export const ButtonWrapper = styled(Button)(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(0.6),
  paddingBottom: theme.spacing(0.6),
  paddingRight: theme.spacing(1.25),
  paddingLeft: theme.spacing(1.25)
}));

export const GridButtonWrapper = styled(Grid)(() => ({
  display: 'flex'
}));

export const ListGridContainerWrapper = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0.62),
  marginTop: theme.spacing(0.62),
  marginBottom: theme.spacing(1.25),
  marginLeft: theme.spacing(0),
  marginRight: theme.spacing(0.62),
  boxShadow: '5px 5px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(51, 51, 51, 0.38)',
  borderRadius: theme.spacing(0.75),
  transition: '0.3s',
  background: props =>
    `linear-gradient(to right, #FFF 50%, ${
      props.offerColor ? props.offerColor : props.folderColor ? props.folderColor : props.facilityColor ? props.facilityColor : '#EEEEEE'
    } 90%)`,
  '&:hover': {
    background: props =>
      `linear-gradient(to right, #FFF 100%, ${
        props.offerColor ? props.offerColor : props.folderColor ? props.folderColor : props.facilityColor ? props.facilityColor : '#EEEEEE'
      } 0%) !important`
  }
}));

export const BoxWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  alignItems: 'center',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.primary.main
}));

export const InlineValueWrapper = styled('span')(({ theme }) => ({
  color: theme.palette.text.highlight,
  fontWeight: theme.typography.fontWeightBold
}));

export const InlineBreakValueWrapper = styled('span')(({ theme }) => ({
  color: theme.palette.text.highlight,
  wordBreak: 'break-all',
  fontWeight: theme.typography.fontWeightMedium
}));

export const PrincipalInfoWrapper = styled(Grid)(({ theme }) => ({
  fontSize: theme.spacing(2)
}));

export const SecondaryInfoWrapper = styled(Grid)(({ theme }) => ({
  fontSize: theme.spacing(1.75)
}));

export const ImportantInfoWrapper = styled('span')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.warning.main
}));
